import React from 'react';
import {
  NationalAccount,
  PricingSummary,
  PreferredPricing,
} from '../../components/PricingBenefits';
import { useIsMobile, useRewardsAndOffers } from '../../hooks';
import '../../styles/app.scss';

export const PricingBenefitsContainer: React.FunctionComponent = () => {
  const { isMobile } = useIsMobile();
  const { isLoading, rewardsAndOffers } = useRewardsAndOffers();

  return (
    <div
      style={{
        visibility: isLoading ? 'hidden' : 'unset',
      }}
    >
      {rewardsAndOffers?.customerInfo && (
        <PricingSummary
          isMobile={isMobile}
          proXtraSpend={rewardsAndOffers?.proXtraSpend}
          userProfile={rewardsAndOffers?.userProfile}
        />
      )}
      <PreferredPricing isMobile={isMobile} />
      <NationalAccount
        isMobile={isMobile}
        nationalAccount={rewardsAndOffers?.customerInfo?.nationalAccountDetails}
      />
    </div>
  );
};
